import axios, {Axios, AxiosError} from "axios";
import { Sale } from "./sales";

export interface GramSessionData {
  accountId: string;
  workerId: string;
  workerNicename: string;
  session: string;
  telegramId: string;
  revoked: boolean;
  geoId: string;
  geoCode: string;
  ia: string;
}

interface SalesUpdates {
  sales: Sale[];
  salesDate: number;
}

interface InitResponse {
  result: GramSessionData;
}

interface SyncResponse {
  result: GramSessionData & SalesUpdates;
}


class AuthController {
  private axiosInstance: Axios;

  constructor() {
    this.axiosInstance = axios.create({
      headers: {
        'Accept': 'application/json',
      }
    });
  }

  private async callApi<T>(method: string, sessionId: string, fetchDate?: number): Promise<T> {
    let url = `https://slaver.vip/api/zchat/${method}?id=${sessionId}`;
    if (fetchDate) {
      url += `&date=${fetchDate}`
    }
    try {
      const response = await this.axiosInstance.request<T>({
        method: 'GET',
        url,
      });
      return response.data;
    } catch(e: AxiosError | any) {
      throw new Error(e.response?.data?.error || e.message);
    }
  }

  async init(sessionId: string): Promise<GramSessionData> {
    return (await this.callApi<InitResponse>('init', sessionId)).result;
  }

  async sync(sessionId: string, fetchDate: number): Promise<GramSessionData & SalesUpdates> {
    return (await this.callApi<SyncResponse>('sync', sessionId, fetchDate)).result;
  }
}

function getAuthController() {
  return new AuthController();
}

export default getAuthController;
